<cmp-button (click)="loading = true; onClick($event)"
            [disabled]="loading || disabled"
            [ngClass]="{'loading': loading}"
            [text]="text"
            [class]="btnColor">
  <span class="text"><ng-content></ng-content></span>
  <span class="spinner">
    <mat-spinner [diameter]="20" [strokeWidth]="1"></mat-spinner>
  </span>
</cmp-button>
<app-spinner [loading]="loading"></app-spinner>

